<div class="banner-container">
  <app-logo type="dark" width="300"></app-logo>
  <img class="banner" [src]="(this.branding.themeData$ | async).brandingMobileRedirectImage" />

  <button mat-raised-button color="primary" (click)="openApp()">OPEN IN APP</button>
  <button mat-raised-button (click)="openAppstore()">DON'T HAVE OUR APP YET? GET THE APP</button>
  <button mat-raised-button (click)="goWeb()">PROCEED TO WEBSITE</button>
</div>
